/** 演示模式已实现的星闪键盘常规灯效 mode（0=常亮 … 9=移动窗格） */
export const XINGSHAN_DEMO_IMPLEMENTED_LIGHTING_MODES = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
] as const;

export type XingshanDemoImplementedLightingMode =
  (typeof XINGSHAN_DEMO_IMPLEMENTED_LIGHTING_MODES)[number];

/** 当前 mode 是否在演示模式星闪灯效支持范围内 */
export function isXingshanDemoImplementedLightingMode(
  mode: number
): mode is XingshanDemoImplementedLightingMode {
  return (
    XINGSHAN_DEMO_IMPLEMENTED_LIGHTING_MODES as readonly number[]
  ).includes(mode);
}
